import { Injectable } from '@angular/core';
import { NATIVE_NAMES } from './language-name.data';

@Injectable({
  providedIn: 'root',
})
export class LanguageNameService {

  public getNativeName(languageCode: string): string {
    return languageCode ? NATIVE_NAMES.get(languageCode.toLowerCase()) ?? languageCode : languageCode;
  }

}
